import {TelephoneTypes} from '../shared/TelephoneTypes';

export class PhoneNumber {
    constructor(sid: number = null, number: string, type: TelephoneTypes = TelephoneTypes.PHONENUMBER_MOBILE) {
        this.sid = sid;
        this.number = number;
        this.type = type;
      }

    sid: number;
    number: string;
    type: TelephoneTypes;
}
